var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166.553,
    height: 52.341,
    viewBox: "0 0 166.553 52.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.492,
    y1: 0.699,
    x2: 0.503,
    y2: -0.023,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92cdc2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.668,
    y1: 0.237,
    x2: 0.388,
    y2: 0.936,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad1f4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: -0.765,
    x2: 0.5,
    y2: 0.566,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020202",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: -0.262,
    x2: 0.5,
    y2: 0.689,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.042,
    x2: 0.5,
    y2: 0.532,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 0.006,
    x2: 0.5,
    y2: 0.752,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: -0.443,
    x2: 0.5,
    y2: 1.778,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 0.016,
    x2: 0.5,
    y2: 0.777,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: -0.032,
    x2: 0.5,
    y2: 0.766,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 0.011,
    x2: 0.5,
    y2: 1.281,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 0.015,
    x2: 0.5,
    y2: 0.776,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    y1: -0.164,
    x2: 0.5,
    y2: 0.714,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.5,
    y1: -0.259,
    x2: 0.5,
    y2: 0.692,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: -0.445,
    x2: 0.5,
    y2: 0.639,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: -1.449,
    x2: 0.5,
    y2: 0.444,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: -6.471,
    x2: 0.5,
    y2: -0.697,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.49,
    y1: -883.59,
    x2: 0.49,
    y2: -51.485,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_111",
    "data-name": "Grupo 111",
    transform: "translate(-358.811 -425.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_108",
    "data-name": "Grupo 108",
    transform: "translate(358.811 425.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1072",
    "data-name": "Trazado 1072",
    d: "M421.132,437.456l-7.481-.076a13.57,13.57,0,0,0-3.71-7.991l3.7-2.2a.449.449,0,0,0-.259-.835l-6.86.438a13.555,13.555,0,0,0-6.414-1.6H377.638a13.62,13.62,0,0,0-13.62,13.62V460.36a13.555,13.555,0,0,0,2.617,8.025l-7.673,8.213a.55.55,0,0,0,.608.886l12.1-4.878a13.565,13.565,0,0,0,5.966,1.374h22.467a13.62,13.62,0,0,0,13.62-13.62V443.6l7.711-5.11A.561.561,0,0,0,421.132,437.456Z",
    transform: "translate(-358.811 -425.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1073",
    "data-name": "Trazado 1073",
    d: "M429.454,431.788s-28.682,8.573-38.4,21.876c0,0,8.972,1.569,11.5,2.269a45.507,45.507,0,0,0-15.609,10.874,1.58,1.58,0,0,1-.245.212,2.036,2.036,0,0,1-3.119-1.752V443.706a12.714,12.714,0,0,1,12.67-12.17l19.349-.049-5.171,3.642S415.645,433.2,429.454,431.788Z",
    transform: "translate(-376.457 -429.674)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1074",
    "data-name": "Trazado 1074",
    d: "M426.613,470.891s-15.718,1.748-23.307,7.425c0,0,9.453,1.332,13.244,3.505,0,0-30.183,7.218-48.149,26.372a53.108,53.108,0,0,1,15.049-7.1l-2.043,1.54a1,1,0,0,0,.6,1.8l24.174.021a12.966,12.966,0,0,0,12.456-12.935V475.137Z",
    transform: "translate(-365.643 -457.744)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1075",
    "data-name": "Trazado 1075",
    d: "M513.059,470.891s-16.536,5.044-18.793,8.261l-4.513-.837S495.91,472.676,513.059,470.891Z",
    transform: "translate(-452.09 -457.744)",
    fill: "#ad1f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1076",
    "data-name": "Trazado 1076",
    d: "M411.91,513.068s.9-.761,3.775,1.027c0,0-35.8,13.309-47.283,24.029C368.4,538.124,383.288,521.5,411.91,513.068Z",
    transform: "translate(-365.643 -487.675)",
    fill: "#ad1f4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_110",
    "data-name": "Grupo 110",
    transform: "translate(421.82 441.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1077",
    "data-name": "Trazado 1077",
    d: "M577.872,495.39l1.846-2.211a6.514,6.514,0,0,0,4.239,1.724c1.278,0,2.049-.507,2.049-1.339v-.041c0-.791-.487-1.2-2.86-1.805-2.86-.73-4.706-1.521-4.706-4.341v-.041c0-2.576,2.069-4.28,4.97-4.28a8.219,8.219,0,0,1,5.274,1.805l-1.623,2.353a6.661,6.661,0,0,0-3.692-1.4c-1.2,0-1.826.548-1.826,1.237v.041c0,.933.609,1.237,3.063,1.866,2.88.751,4.5,1.785,4.5,4.26v.041c0,2.82-2.15,4.4-5.213,4.4A9.035,9.035,0,0,1,577.872,495.39Z",
    transform: "translate(-577.872 -482.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1078",
    "data-name": "Trazado 1078",
    d: "M617.926,502.366v-7.039h3.083v6.065c0,1.461.69,2.211,1.866,2.211s1.927-.75,1.927-2.211v-6.065h3.083V506.2H624.8v-1.542a3.847,3.847,0,0,1-3.185,1.744C619.285,506.4,617.926,504.861,617.926,502.366Z",
    transform: "translate(-606.405 -491.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1079",
    "data-name": "Trazado 1079",
    d: "M655.087,494.826h3.083v1.562a3.992,3.992,0,0,1,3.388-1.765c2.535,0,4.949,1.988,4.949,5.619v.041c0,3.631-2.373,5.619-4.949,5.619a4.175,4.175,0,0,1-3.388-1.623v4.665h-3.083Zm8.337,5.457v-.041a2.668,2.668,0,1,0-5.295,0v.041a2.668,2.668,0,1,0,5.295,0Z",
    transform: "translate(-632.878 -490.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1080",
    "data-name": "Trazado 1080",
    d: "M693.8,500.323v-.04a5.413,5.413,0,0,1,5.375-5.659c3.631,0,5.294,2.819,5.294,5.9,0,.243-.02.527-.041.811h-7.566a2.521,2.521,0,0,0,2.657,2.13,3.562,3.562,0,0,0,2.637-1.115l1.765,1.562a5.743,5.743,0,0,1-10.122-3.591Zm7.668-.912a2.332,2.332,0,0,0-2.292-2.313,2.424,2.424,0,0,0-2.353,2.313Z",
    transform: "translate(-660.455 -490.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1081",
    "data-name": "Trazado 1081",
    d: "M731.807,494.814h3.083V497a3.358,3.358,0,0,1,3.469-2.393v3.225H738.2c-2.049,0-3.307,1.238-3.307,3.834v4.017h-3.083Z",
    transform: "translate(-687.53 -490.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1082",
    "data-name": "Trazado 1082",
    d: "M754.1,483.761h3.246l2.049,6,5.294-6H768.3l-3.813,14.2h-3.165l2.475-9.27-5.558,6.065h-.081l-2.272-6-2.475,9.209h-3.124Z",
    transform: "translate(-700.692 -483.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1083",
    "data-name": "Trazado 1083",
    d: "M805.5,503.18c0-2.515,2.049-3.915,4.686-3.915a10,10,0,0,1,3.063.487l.041-.142a3.106,3.106,0,0,0,.122-.812c0-.751-.527-1.278-2.049-1.278a7.935,7.935,0,0,0-2.9.588l-.487-2.434a10.519,10.519,0,0,1,4.037-.771c2.921,0,4.4,1.217,4.4,3.347a6.44,6.44,0,0,1-.243,1.643l-1.6,6h-2.982l.325-1.258a4.342,4.342,0,0,1-3.246,1.461A2.914,2.914,0,0,1,805.5,503.18Zm7.221-1.379.081-.284a5.92,5.92,0,0,0-2.029-.385c-1.278,0-2.211.649-2.211,1.7,0,.67.548,1.156,1.42,1.156A3.012,3.012,0,0,0,812.718,501.8Z",
    transform: "translate(-740.025 -491.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1084",
    "data-name": "Trazado 1084",
    d: "M844,497.37a5.521,5.521,0,0,1,.2-1.359l1.318-4.929h-1.3l.71-2.637h1.3l.75-2.779h3.083l-.75,2.779h2.556l-.71,2.637H848.6l-1.217,4.564a2.428,2.428,0,0,0-.081.487c0,.406.264.649.832.649a4.134,4.134,0,0,0,1.582-.345l-.71,2.617a5.4,5.4,0,0,1-2.232.446C844.911,499.5,844,498.567,844,497.37Z",
    transform: "translate(-767.452 -484.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1085",
    "data-name": "Trazado 1085",
    d: "M866,501.033a6.45,6.45,0,0,1,6.41-6.41,4.754,4.754,0,0,1,4.463,2.393l-2.353,1.664a2.574,2.574,0,0,0-2.353-1.42c-1.622,0-3.124,1.765-3.124,3.773a2.124,2.124,0,0,0,2.13,2.292,3.6,3.6,0,0,0,2.455-1.075l1.582,2.008a5.726,5.726,0,0,1-4.138,1.684A4.75,4.75,0,0,1,866,501.033Z",
    transform: "translate(-783.125 -490.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1086",
    "data-name": "Trazado 1086",
    d: "M900.608,481.646h3.083l-1.339,5.071a4.483,4.483,0,0,1,2.962-1.339,2.961,2.961,0,0,1,3.2,3.164,8.9,8.9,0,0,1-.365,2.069l-1.562,5.842h-3.083l1.6-5.964a4.341,4.341,0,0,0,.142-.974c0-.872-.548-1.339-1.5-1.339a2.494,2.494,0,0,0-2.353,2.171l-1.643,6.106h-3.083Z",
    transform: "translate(-804.976 -481.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_109",
    "data-name": "Grupo 109",
    transform: "translate(0.952 6.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1087",
    "data-name": "Trazado 1087",
    d: "M591.469,517.805v-.041c0-.081-.006-.156-.01-.234q-1.614.369-3.109.768c-.11.719-.855,1.151-2.033,1.151a5.568,5.568,0,0,1-1.332-.165q-2.064.664-3.8,1.389a9.1,9.1,0,0,0,5.073,1.534C589.319,522.207,591.469,520.625,591.469,517.805Z",
    transform: "translate(-581.183 -513.821)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1088",
    "data-name": "Trazado 1088",
    d: "M621.621,517.592a3.847,3.847,0,0,0,3.185-1.745v1.541h3.083v-6.338q-1.575.223-3.083.472v1.059c0,1.46-.75,2.211-1.927,2.211s-1.866-.751-1.866-2.211V512.2q-1.589.31-3.083.647v.708C617.929,516.05,619.288,517.592,621.621,517.592Z",
    transform: "translate(-607.36 -509.205)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1089",
    "data-name": "Trazado 1089",
    d: "M658.173,517.522v-4.665a4.176,4.176,0,0,0,3.388,1.623,4.886,4.886,0,0,0,4.815-4.212,6.314,6.314,0,0,1-.151-1.367v-.04a6.28,6.28,0,0,1,.161-1.4,6.235,6.235,0,0,0-.2-.783q-1.672.124-3.3.272a3.266,3.266,0,0,1,.544,1.865v.041a2.668,2.668,0,1,1-5.295,0v-.041a3.479,3.479,0,0,1,.282-1.4q-1.694.2-3.324.421v9.683Z",
    transform: "translate(-633.832 -506.094)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1090",
    "data-name": "Trazado 1090",
    d: "M694.462,507.566v.041a7.368,7.368,0,0,1-.134,1.407,5.78,5.78,0,0,0,9.971,2.224l-1.765-1.562a3.562,3.562,0,0,1-2.637,1.116,2.521,2.521,0,0,1-2.657-2.13h7.566c.02-.284.041-.568.041-.811a7.267,7.267,0,0,0-.584-2.928q-1.6.043-3.179.108a2.913,2.913,0,0,1,.76,1.7H697.2a3.229,3.229,0,0,1,.67-1.549q-1.665.093-3.29.211a5.936,5.936,0,0,0-.242.816A7.289,7.289,0,0,1,694.462,507.566Z",
    transform: "translate(-661.784 -504.839)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1091",
    "data-name": "Trazado 1091",
    d: "M694.088,510.759a7.289,7.289,0,0,0-.125-1.354,6.28,6.28,0,0,0-.161,1.4v.04a6.314,6.314,0,0,0,.151,1.367,7.368,7.368,0,0,0,.134-1.407Z",
    transform: "translate(-661.41 -508.033)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1092",
    "data-name": "Trazado 1092",
    d: "M734.894,512.817V508.8c0-2.6,1.258-3.834,3.306-3.834h.162v-.329q-.618,0-1.238,0-2.689,0-5.314.062v8.122Z",
    transform: "translate(-688.486 -504.634)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1093",
    "data-name": "Trazado 1093",
    d: "M788.651,513.756h3.164l2.041-7.6q-1.543-.114-3.121-.207Z",
    transform: "translate(-728.977 -505.572)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1094",
    "data-name": "Trazado 1094",
    d: "M773.058,509.808h.081l4.262-4.651q-3.04-.165-6.2-.249Z",
    transform: "translate(-716.548 -504.829)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1095",
    "data-name": "Trazado 1095",
    d: "M753.41,512.846l2.183-8.122q-1.544-.036-3.112-.05l-2.195,8.172Z",
    transform: "translate(-701.647 -504.663)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1096",
    "data-name": "Trazado 1096",
    d: "M813.249,509.874a9.989,9.989,0,0,0-3.063-.487c-2.637,0-4.686,1.4-4.686,3.915a2.914,2.914,0,0,0,3.164,2.921,4.343,4.343,0,0,0,3.246-1.461l-.325,1.258h2.982l1.6-6c.046-.178.086-.354.121-.53q-1.42-.188-2.889-.356a3.609,3.609,0,0,1-.112.6Zm-.527,2.048a3.012,3.012,0,0,1-2.738,2.191c-.872,0-1.42-.487-1.42-1.156,0-1.055.933-1.7,2.211-1.7a5.918,5.918,0,0,1,2.028.385Z",
    transform: "translate(-740.979 -507.837)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1097",
    "data-name": "Trazado 1097",
    d: "M844,515.395c0,1.2.913,2.13,2.779,2.13a5.4,5.4,0,0,0,2.231-.446l.71-2.617a4.131,4.131,0,0,1-1.582.345c-.568,0-.832-.244-.832-.649a2.417,2.417,0,0,1,.081-.487l.6-2.236q-1.453-.235-2.965-.449l-.816,3.05A5.526,5.526,0,0,0,844,515.395Z",
    transform: "translate(-768.407 -509.159)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1098",
    "data-name": "Trazado 1098",
    d: "M871.073,519.716a5.724,5.724,0,0,0,4.133-1.68l0-.007-1.579-2a3.6,3.6,0,0,1-2.454,1.075,2.124,2.124,0,0,1-2.13-2.292c0-.084.006-.167.011-.25q-1.458-.3-3-.581a6.385,6.385,0,0,0-.056.831A4.75,4.75,0,0,0,871.073,519.716Z",
    transform: "translate(-784.079 -511.289)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1099",
    "data-name": "Trazado 1099",
    d: "M897.063,523.5l0,0-.382,1.436h3.083l.643-2.391q-1.353-.463-2.853-.9l-.49,1.844Z",
    transform: "translate(-805.93 -516.76)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1100",
    "data-name": "Trazado 1100",
    d: "M920.443,530.416h2.508c-.677-.368-1.419-.727-2.218-1.078Z",
    transform: "translate(-822.861 -522.232)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1101",
    "data-name": "Trazado 1101",
    d: "M898.005,528.066l0,.008,0,0Z",
    transform: "translate(-806.876 -521.326)",
    fill: "url(#linear-gradient-17)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.3b83581f1b20e50ac7318952f4dc5990.svg";
export { ForwardRef as ReactComponent };